'use client';

import React from 'react';
import Image from 'next/image';
import { Button } from '@/components/ui/Button';
import Link from 'next/link';
import PageHeader from '@/components/ui/PageHeader';

export default function AboutPage() {
  return (
    <div>
      <PageHeader 
        title="Hakkımızda" 
        subtitle="Filiz Dekorasyon Kozmetik olarak kaliteli ve dayanıklı ürünlerle hizmetinizdeyiz"
        theme="primary"
        size="medium"
        fontStyle="normal"
        animation="fade"
        align="center"
        breadcrumbs={[
          { label: 'Hakkımızda', url: '/hakkimizda' }
        ]}
      />
      
      <div className="bg-white py-8 md:py-12">
        <div className="container mx-auto px-4">
          {/* Hikayemiz */}
          <div className="bg-white rounded-lg shadow-sm p-6 md:p-10 mb-12">
            <div className="max-w-3xl mx-auto text-center">
                <div className="mb-4">
                  <div className="inline-block px-3 py-1 text-xs font-medium text-primary bg-primary/10 rounded-full mb-2">Filiz Dekorasyon Kozmetik</div>
                  <h2 className="text-2xl md:text-3xl font-bold mb-4">
                    <span className="text-primary">Hikayemiz</span> <span className="text-gray-900">ve Başarılarımız</span>
                  </h2>
                </div>
                <div className="space-y-4 text-gray-600">
                  <p>
                    FİLİZ DEKORASYON KOZMETİK markası adı altında kuruluşundan bu yana ÜSTÜN HİZMET ve %100 KALİTE ilkesini hedefleyen şirketimiz, Kuaför Salonlarının her türlü ihtiyacını karşılarken, farklı Tasarım seçenekleriyle Kuaför Salon Mobilyası sektöründe hizmet vermeye devam etmektedir. Profesyonel kadrosu ile çağın ihtiyaçlarını yakından takip eden şirketimiz, Kuaför Salonlarında sektörün modasını yaşatmaktadır.
                  </p>
                  <p>
                    Bay & Bayan Tezgâhlarından Komodin Gruplarına, Bay Berber Koltuklarından Bayan Kuaför Koltuklarına, Yıkama setlerinden Bay & Bayan Oturma Gruplarına, Bekleme Gruplarından Masaj & Ağda Yataklarına, Çocuk Tezgâhlarından Çocuk Oturma Gruplarına ve Aksesuar & Aparatlarına kadar Kuaför Salon Mobilyasında ihtiyaç duyulan her grupta hizmet veren FİLİZ DEKORASYON KOZMETİK kuaförlerimize sanatlarını en mükemmel şekilde yansıtabilecekleri mekanları sunuyor... Türkiye ve Dünyadaki pek çok yere FİLİZ DEKORASYON KOZMETİK markası adı altında satış yapan şirketimiz hizmet kalitesini sürekli artırmaktadır.
                  </p>
                  <p>
                    Şirketimiz sektörümüzde hızla büyüyen şirketler arasında rekabetini sürdürürken, MÜŞTERİ ODAKLI hizmet kalitesini uluslararası standartlara taşımıştır.
                  </p>
                  <div>
                    <h3 className="text-xl font-bold text-primary mb-2">Misyonumuz</h3>
                    <ul className="list-disc pl-6 text-gray-700 text-base space-y-1">
                      <li>Müşterilerimize,</li>
                      <li>En hızlı,</li>
                      <li>En güvenli,</li>
                      <li>En kaliteli ürün ve hizmeti</li>
                      <li>En uygun fiyata sunmaktır.</li>
                    </ul>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-primary mb-2">Vizyonumuz</h3>
                    <p className="text-gray-700 text-base">
                      Sektörümüzde Türkiye’de ve Dünya’da ürün ve hizmet kalitesi açısından en önde gelen ve sektörün modasını takip eden değil belirleyen şirket olmaktır.
                    </p>
                  </div>
                  <p>
                    Şirketimiz profesyonel kadrosu ile çağın ihtiyaçlarını yakından takip ederek, kuaför salonlarında sektörün modasını yaşatmaya devam etmektedir.
                  </p>
                  <p>
                    Başlangıçta küçük bir atölyede üretim yapan firmamız, yıllar içinde sektörün önde gelen tedarikçilerinden biri haline geldi. Bugün ikinci kuşak yönetiminde, modern üretim teknikleri ve geleneksel el işçiliğini bir araya getirerek Türkiye genelinde yüzlerce berber ve kuaför salonuna hizmet vermekteyiz.
                  </p>
                </div>
            </div>
          </div>

          {/* Neden Biz */}
          <div className="bg-white rounded-lg shadow-sm p-6 md:p-10 mb-12">
            <div className="text-center mb-8">
              <div className="inline-block px-3 py-1 text-xs font-medium text-primary bg-primary/10 rounded-full mb-2">Farklılığımız</div>
              <h2 className="text-2xl md:text-3xl font-bold">
                <span className="text-primary">Neden</span> <span className="text-gray-900">Filiz Dekorasyon Kozmetik?</span>
              </h2>
            </div>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-primary flex items-center justify-center text-white text-lg font-bold">1</div>
                <div>
                  <h3 className="text-lg font-semibold mb-2 text-gray-900">Sektörel Deneyim</h3>
                  <p className="text-gray-600">25 yılı aşkın sektör deneyimimizle berber ve kuaför mobilyalarının tüm inceliklerini biliyoruz.</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-primary flex items-center justify-center text-white text-lg font-bold">2</div>
                <div>
                  <h3 className="text-lg font-semibold mb-2 text-gray-900">Kişiye Özel Çözümler</h3>
                  <p className="text-gray-600">Standart ürünlerimizin yanı sıra, salonunuza özel ölçü ve tasarımlarda ürünler üretebiliyoruz.</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-primary flex items-center justify-center text-white text-lg font-bold">3</div>
                <div>
                  <h3 className="text-lg font-semibold mb-2 text-gray-900">Garantili Ürünler</h3>
                  <p className="text-gray-600">Tüm ürünlerimiz 2 yıl garanti kapsamındadır ve satış sonrası servis desteği sunuyoruz.</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-primary flex items-center justify-center text-white text-lg font-bold">4</div>
                <div>
                  <h3 className="text-lg font-semibold mb-2 text-gray-900">Türkiye Geneli Teslimat</h3>
                  <p className="text-gray-600">Türkiye'nin her yerine montaj dahil teslimat yapıyor, salonunuzu kullanıma hazır hale getiriyoruz.</p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center">
            <h2 className="text-2xl md:text-3xl font-bold mb-4">
              <span className="text-primary">Hizmetlerimiz</span> <span className="text-gray-900">hakkında daha fazla bilgi mi istiyorsunuz?</span>
            </h2>
            <p className="mb-6 text-gray-600 max-w-2xl mx-auto">Salonunuza özel çözümler için bizimle iletişime geçin, uzman ekibimiz size en kısa sürede yardımcı olsun.</p>
            <Link href="/iletisim" passHref>
              <Button>
                İletişime Geçin
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
} 